import type { DirectUrlJob, GoogleSearchJob, InternalScrapingJob } from '../types/types';

import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { internalApiClient } from '@/shared/api-client/internal-api-client';
import { omitNullish } from '@/shared/utils/omit-nullish';

// Base job fields shared by all job types

export async function fetchInternalScrapingJobs<
  T extends 'GOOGLE_SEARCH' | 'DIRECT_URL' | undefined = undefined,
>({
  page,
  limit,
  platform,
  type,
  keyword,
  jobType,
  status,
  owner,
}: {
  page: number;
  limit: number;
  platform?: SOURCE_PLATFORM_TYPE;
  type?: T;
  keyword?: string;
  jobType?: 'onetime' | 'periodic';
  status?: 'IN_PROGRESS' | 'DONE';
  owner?: string;
}): Promise<{
  jobs: T extends 'GOOGLE_SEARCH'
    ? GoogleSearchJob[]
    : T extends 'DIRECT_URL'
      ? DirectUrlJob[]
      : InternalScrapingJob[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}> {
  const _status = (() => {
    if (status === 'IN_PROGRESS') {
      return 'ACTIVE';
    }
    if (status === 'DONE') {
      return 'INACTIVE';
    }
    return undefined;
  })();

  const response = await internalApiClient.get<{
    jobs: InternalScrapingJob[];
    totalCount: number;
    totalPages: number;
    currentPage: number;
  }>('social-post-scraping-jobs', {
    searchParams: omitNullish({
      platform,
      page,
      limit,
      type,
      keyword,
      jobType,
      status: _status,
      owner,
    }),
  });

  return response.json();
}
